import styled from "styled-components";
import colors from "@streeteasy/design-system/deprecated/colors";
import Text from "@streeteasy/design-system/deprecated/Text";
import { lighten } from "polished";

const theme = {
  default: {
    border: `1px solid ${colors.rabbitGrey}`,
    backgroundColor: "white"
  },
  blue: {
    border: `1px solid #0294E5`,
    backgroundColor: `${colors.frostedGlass}`
  },
  red: {
    border: `1px solid ${colors.errorRed}`,
    backgroundColor: `${lighten(0.4, colors.errorRed)}`
  }
};

const Container = styled.div`
  align-items: center;
  background-color: ${props => theme[props.theme].backgroundColor};
  border: ${props => theme[props.theme].border};
  border-radius: 4px;
  box-sizing: border-box;
  display: flex;
  margin: 0 auto;
  max-width: 696px;
  padding: 14px;
  width: 100%;

  button {
    height: 10px;
    width: 9px;
  }
  ${props => props.optionalStyles};
`;

const Toast = styled.div`
  box-sizing: border-box;
  left: 50%;
  max-width: 696px;
  padding: 0 10px;
  position: fixed;
  top: ${props => props.offsetY};
  transform: translate(-50%, 0);
  width: ${props => (props.isAutoWidth ? "auto" : "100%")};
  z-index: 9999;
`;

const Icon = styled.i.attrs(props => ({
  className: `fa fa-${props.icon}`
}))`
  align-self: flex-start;
  color: ${props =>
    props.theme === "red" ? colors.errorRed : colors.classicBlue};
  font-size: 16px;
  margin-top: 2px;
  padding: 0;
`;

const ToastText = styled(Text)`
  padding-left: 15px;
  padding-right: 40px;
`;

Container.displayName = "Container";
Icon.displayName = "Icon";
ToastText.displayName = "ToastText";

export { Container, Icon, ToastText, Toast };
